import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ClientAuthProvider } from './context/ClientAuthContext'
import ClientApp from './ClientApp'
import './styles/globals.css'

// Auto theme switching based on time
// Dark: 6pm (18:00) to 7am (07:00)
// Light: 7am (07:00) to 6pm (18:00)
function getThemeByTime() {
  const hour = new Date().getHours()
  if (hour >= 7 && hour < 18) {
    return 'light'
  }
  return 'dark'
}

function applyTheme(theme) {
  document.documentElement.setAttribute('data-theme', theme)
  localStorage.setItem('redstone-theme', theme)
  localStorage.setItem('redstone-theme-auto', 'true')
}

function initTheme() {
  const isAuto = localStorage.getItem('redstone-theme-auto') !== 'false'

  if (isAuto) {
    const theme = getThemeByTime()
    applyTheme(theme)
  } else {
    const storedTheme = localStorage.getItem('redstone-theme') || 'dark'
    document.documentElement.setAttribute('data-theme', storedTheme)
  }
}

// Initialize theme immediately
initTheme()

// Check theme every minute to auto-switch at boundaries
setInterval(() => {
  const isAuto = localStorage.getItem('redstone-theme-auto') !== 'false'
  if (isAuto) {
    const currentTheme = document.documentElement.getAttribute('data-theme')
    const newTheme = getThemeByTime()
    if (currentTheme !== newTheme) {
      applyTheme(newTheme)
    }
  }
}, 60000)

// Export theme utilities for use in components
window.themeUtils = {
  setTheme: (theme) => {
    localStorage.setItem('redstone-theme-auto', 'false')
    localStorage.setItem('redstone-theme', theme)
    document.documentElement.setAttribute('data-theme', theme)
  },
  setAutoTheme: () => {
    localStorage.setItem('redstone-theme-auto', 'true')
    applyTheme(getThemeByTime())
  },
  getTheme: () => document.documentElement.getAttribute('data-theme'),
  isAutoMode: () => localStorage.getItem('redstone-theme-auto') !== 'false'
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <ClientAuthProvider>
        <ClientApp />
      </ClientAuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
